import React from "react";

import {
  A11y,
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import { Rating } from "@mui/material";
import { testos } from "../data/testos";
const Testimonials = () => {
  return (
    <section className="bg-yellow-50 py-20 relative">
      <div className="w-20 h-20 -mt-10 absolute top-0 left-1/2 -translate-x-1/2 bg-white rotate-45"></div>
      <div className="w-20 h-20 absolute -bottom-10 left-1/2 -translate-x-1/2 bg-yellow-50 rotate-45"></div>
      <h2 className="text-5xl font-bold text-center mb-20">
        Happy Clients & Feedbacks
      </h2>
      <div className="max-screen">
        <Swiper
          slidesPerView={1}
          spaceBetween={24}
          breakpoints={{
            640: {
              slidesPerView: 1.5,
            },
            1024: {
              slidesPerView: 2,
            },
          }}
          pagination={{
            clickable: true,
          }}
          loop={true}
          autoplay={{
            delay: 3000,
          }}
          modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
          className="testo-slide">
          {testos.map((item, index) => {
            return (
              <SwiperSlide key={index}>
                <SingleSlide {...item} />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonials;

const SingleSlide = (item) => {
  return (
    <div className=" rounded-2xl">
      <blockquote className="p-4 xl:p-8 flex flex-col gap-4 justify-between 2xl:p-12">
        <div className="flex items-center gap-2 xl:gap-4">
          <img
            alt={item.name}
            src={item.image}
            className="h-16 w-16 rounded-full object-cover"
          />
          <div className="ml-4 text-sm">
            <p className="font-bold text-xl text-dark-blue">{item.name}</p>
            <p className="mt-1 text-[18px]">{item.position}</p>
          </div>
        </div>
        <Rating name="read-only" value={item.rating} readOnly />
        <div>
          <p className="relative mt-4 text-gray-500 xl:text-xl">
            {item.description}
          </p>
        </div>
      </blockquote>
    </div>
  );
};


